import gql from 'graphql-tag';

const DestroyDriverSession = gql(/* GraphQL */ `
  mutation DestroyDriverSession($input: DestroyDriverSessionInput!) {
    destroyDriverSession(input: $input) {
      userErrors {
        ... on UserError {
          message
        }
      }
    }
  }
`);

export default DestroyDriverSession;
